import React from 'react'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import { FaCaretLeft } from "react-icons/fa6";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { FaScrewdriverWrench } from "react-icons/fa6";
import { FaKey } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";

import bgimage from '../images/wpimage.png'
import Templatemodal from './templatemodal';

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}

function getUserIdFromTokenOrLocatorgarsotrga() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            const userId = decoded.id || decoded.userId || decoded._id;
            return { userId, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        const userId = decoded.id || decoded.userId || decoded._id;
        return { userId, token: rawToken };
    }
    return { userId: null, token: null };
}
const API_URL = process.env.REACT_APP_API_BASE;

function Templatelibrary() {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [open, setopen] = useState(false)
    const [selectedItem, setSelectedItem] = useState({});
    const [Example, setExample] = useState(false)
    const [searchfilter, setsearchfiltertemplate] = useState('')
    const [selectUtitlitycheckbox, setselectUtitlitycheckbox] = useState([])
    const [selectAuthcheckbox, setselectAuthcheckbox] = useState([])
    const [selectType, setselectType] = useState('AUTHENTICATION')
    const [AccountUpadets, setAccountUpadets] = useState(false)
    const { userId } = getUserIdFromTokenOrLocatorgarsotrga();

    // -- Fix: Memoize filtered templates for labels
    const authenticationTemplates = React.useMemo(
        () => templates.filter(t => t.type === 'AUTHENTICATION'),
        [templates]
    );
    const authenticationCount = authenticationTemplates.length;
    const utilityTemplates = React.useMemo(
        () => templates.filter(t => t.type === 'utility'),
        [templates]
    );
    const utilityCount = utilityTemplates.length;

    React.useEffect(() => {
        if (templates.length > 0 && (selectType === 'AUTHENTICATION(2)' || selectType === 'AUTHENTICATION')) {
            setselectType('AUTHENTICATION');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templates]);

    // ─── Fetch templates from API ───────────────────────────────────────────────
    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                setLoading(true);
                setError(null);

                if (!userId) {
                    setError('User not found. Please log in again.');
                    setLoading(false);
                    return;
                }

                // 1. Get waba_ids
                const wabaRes = await fetch(`${API_URL}/auth/whatsapp/waba_ids?user_id=${userId}`, {
                    credentials: 'include',
                });
                if (!wabaRes.ok) throw new Error('Failed to fetch WABA IDs');
                const wabaData = await wabaRes.json();

                const wabaIds = wabaData.waba_ids || [];
                if (!wabaIds.length) {
                    setTemplates([]);
                    setLoading(false);
                    return;
                }

                // 2. Fetch templates for each waba_id
                const allTemplates = [];
                for (const wabaId of wabaIds) {
                    const tplRes = await fetch(`${API_URL}/auth/whatsapp/meta_templates/full?waba_id=${wabaId}`, {
                        credentials: 'include',
                    });
                    if (!tplRes.ok) continue;
                    const tplData = await tplRes.json();

                    // Normalize
                    const normalized = tplData.map((t) => {
                        const bodyComp = t.components?.find(c => c.type === 'BODY');
                        const headerComp = t.components?.find(c => c.type === 'HEADER');
                        const footerComp = t.components?.find(c => c.type === 'FOOTER');
                        const buttonsComp = t.components?.find(c => c.type === 'BUTTONS');
                        const urlBtn = buttonsComp?.buttons?.find(b => b.type === 'URL');

                        return {
                            id: t.id,
                            name: t.name,
                            header: headerComp?.text || '',
                            body: bodyComp?.text || '',
                            footer: footerComp?.text || '',
                            buttonText: buttonsComp?.buttons?.[0]?.text || '',
                            link: urlBtn?.url || null,
                            // Ensure lowercase for type for utility, and keep AUTHENTICATION as string to match radio input values
                            type: (t.category && t.category.toUpperCase() === 'UTILITY') ? 'utility' : (
                                (t.category && t.category.toUpperCase() === 'AUTHENTICATION') ? 'AUTHENTICATION' : t.category
                            ),
                            utility: t.name,
                            AUTHENTICATION: t.name,
                            status: t.status,
                            language: t.language,
                            waba_id: wabaId,
                        };
                    });

                    allTemplates.push(...normalized);
                }

                setTemplates(allTemplates);
            } catch (err) {
                console.error('Error fetching templates:', err);
                setError('Failed to load templates. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchTemplates();
    }, [userId]);

    // Checkbox handler
    const handelchanges = (value, setselectbox) => {
        setselectbox(
            (prev) =>
                prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
        )
    }

    // --- Fix filter: Make filter logic always ANDs all selected checkbox for the current type ---
    const filteredTemplates = React.useMemo(() => {
        return templates.filter((item) => {
            // filter by type
            const matchesType = !selectType || item.type === selectType;

            // filter by search
            const matchesSearch = item.name
                ? item.name.toLowerCase().includes(searchfilter.trim().toLowerCase())
                : false;

            // For utility templates, filter with selectUtitlitycheckbox; for auth, with selectAuthcheckbox
            if (item.type === "utility") {
                // If any util checkbox is checked, show only matching
                if (selectUtitlitycheckbox.length > 0) {
                    if (!selectUtitlitycheckbox.includes(item.utility)) return false;
                }
            }
            if (item.type === "AUTHENTICATION") {
                if (selectAuthcheckbox.length > 0) {
                    if (!selectAuthcheckbox.includes(item.AUTHENTICATION)) return false;
                }
            }
            return matchesType && matchesSearch;
        });
    }, [templates, selectType, searchfilter, selectUtitlitycheckbox, selectAuthcheckbox]);

    return (
        <>
            <div className='w-[100%] px-4'>
                <div className='w-[100%] flex flex-col sm:flex-row sm:items-center gap-3'>

                    <div className='w-full sm:w-[30%] flex gap-1 items-center'>
                        <FaArrowLeftLong />
                        <span className='text-[14px] text-[#000] font-semibold'>
                            Template Library
                        </span>
                    </div>

                    <div className='w-full sm:w-[70%] flex flex-col sm:flex-row gap-2'>

                        <div className='w-full sm:w-[80%] border-[1px] border-[#d4cfcf] rounded-md flex items-center px-4 py-2 gap-2'>
                            <FaSearch className='text-[#686666] text-[12px]' />
                            <input
                                type="text"
                                className='outline-none text-[#686666] text-[12px] font-semibold w-full'
                                placeholder='Search utility Template'
                                value={searchfilter}
                                onChange={(e) => setsearchfiltertemplate(e.target.value)}
                            />
                        </div>

                        <select className='w-full sm:w-[15%] border-[1px] border-[#d4cfcf] rounded-md text-[12px] font-semibold text-[#000] px-2 py-2 '>
                            <option>English Template</option>
                            <option>Hindi Template</option>
                        </select>

                    </div>
                </div>

                <div className='w-[100%] flex mt-4'>
                    <div className='w-[25%] px-4'>
                        <div className='flex items-center gap-2'>
                            <input
                                type="radio"
                                name="type"
                                id="utility"
                                value="utility"
                                checked={selectType === "utility"}
                                onChange={(e) => setselectType(e.target.value)}
                                className='accent-[#448c74]'
                            />
                            <label htmlFor="utility"
                                className='text-[#686666] text-[12px] font-semibold flex items-center gap-2'>
                                <FaScrewdriverWrench className='text-[#3f7fca]' /> Utility
                                {typeof utilityCount !== "undefined" ?
                                    <span className="ml-1 text-xs bg-gray-200 text-gray-600 rounded-full px-2 py-[2px] flex items-center">{utilityCount}</span>
                                    : null}
                            </label>
                        </div>
                        <div className='flex items-center gap-2 mt-5'>
                            <input
                                type="radio"
                                name="type"
                                id="AUTHENTICATION"
                                value="AUTHENTICATION"
                                checked={selectType === "AUTHENTICATION"}
                                onChange={(e) => setselectType(e.target.value)}
                                className='accent-[#448c74]'
                            />
                            <label htmlFor="AUTHENTICATION"
                                className='text-[#686666] text-[12px] font-semibold flex items-center gap-2'>
                                <FaKey className='text-[#edcb50]' /> AUTHENTICATION
                                {typeof authenticationCount !== "undefined" ?
                                    <span className="ml-1 text-xs bg-gray-200 text-gray-600 rounded-full px-2 py-[2px] flex items-center">{authenticationCount}</span>
                                    : null}
                            </label>
                        </div>

                        {selectType === 'utility' &&
                            <div className='border-[1px] border-[#d4cfcf] rounded-md mt-6'>
                                <div
                                    onClick={() => setAccountUpadets(!AccountUpadets)}
                                    className='w-[100%] flex items-center justify-between p-2'>
                                    <span className='text-[#121519d1] font-semibold text-[13px]'>Account Updates</span>
                                    {AccountUpadets ?
                                        <IoIosArrowForward className='text-[#121519d1] font-semibold text-[13px]' /> :
                                        <IoIosArrowDown className='text-[#121519d1] font-semibold text-[13px]' />
                                    }
                                </div>
                                {AccountUpadets &&
                                    <div className='w-[100%] p-2'>
                                        {utilityTemplates
                                            .map((t) => (
                                                <div key={t.id} className='flex items-center gap-2 mt-2'>
                                                    <input
                                                        type="checkbox"
                                                        id={`utility-${t.id}`}
                                                        value={t.utility}
                                                        checked={selectUtitlitycheckbox.includes(t.utility)}
                                                        onChange={(e) => handelchanges(e.target.value, setselectUtitlitycheckbox)}
                                                    />
                                                    <label htmlFor={`utility-${t.id}`} className='text-[#121519d1] text-[13px] font-semibold'>
                                                        {t.name}
                                                    </label>
                                                </div>
                                            ))
                                        }
                                    </div>
                                }
                            </div>
                        }

                        {selectType === 'AUTHENTICATION' &&
                            <div className='border-[1px] border-[#d4cfcf] rounded-md mt-6'>
                                <div
                                    onClick={() => setAccountUpadets(!AccountUpadets)}
                                    className='w-[100%] flex items-center justify-between p-2'>
                                    <span className='text-[#121519d1] font-semibold text-[13px]'>In Person Verifications</span>
                                    {AccountUpadets ?
                                        <IoIosArrowForward className='text-[#121519d1] font-semibold text-[13px]' /> :
                                        <IoIosArrowDown className='text-[#121519d1] font-semibold text-[13px]' />
                                    }
                                </div>
                                {AccountUpadets &&
                                    <div className='w-[100%] p-2'>
                                        {authenticationTemplates
                                            .map((t) => (
                                                <div key={t.id} className='flex items-center gap-2 mt-2'>
                                                    <input
                                                        type="checkbox"
                                                        id={`auth-${t.id}`}
                                                        value={t.AUTHENTICATION}
                                                        checked={selectAuthcheckbox.includes(t.AUTHENTICATION)}
                                                        onChange={(e) => handelchanges(e.target.value, setselectAuthcheckbox)}
                                                    />
                                                    <label htmlFor={`auth-${t.id}`} className='text-[#121519d1] text-[13px] font-semibold'>
                                                        {t.name}
                                                    </label>
                                                </div>
                                            ))
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    {/* ── Template Grid ── */}
                    <div className='w-[75%] bg-[linear-gradient(175deg,_rgb(203_216_228)_0%,_rgb(192_213_225)_25%,_rgb(184_202_215)_50%,_rgb(193,210,255)_75%,_rgb(233_231_235)_100%)] p-4 flex flex-wrap justify-between gap-y-4 h-[500px] overflow-y-auto'>

                        {/* Loading state */}
                        {loading && (
                            <div className='w-full flex items-center justify-center h-full'>
                                <span className='text-[#576071] text-[14px] font-semibold animate-pulse'>
                                    Loading templates...
                                </span>
                            </div>
                        )}

                        {/* Error state */}
                        {!loading && error && (
                            <div className='w-full flex items-center justify-center h-full'>
                                <span className='text-red-500 text-[14px] font-semibold'>{error}</span>
                            </div>
                        )}

                        {/* Empty state */}
                        {!loading && !error && filteredTemplates.length === 0 && (
                            <div className='w-full flex items-center justify-center h-full'>
                                <span className='text-[#858c97] text-[14px] font-semibold'>No templates found.</span>
                            </div>
                        )}

                        {/* Template cards */}
                        {!loading && !error && filteredTemplates.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => setSelectedItem(item)}
                                className='w-[32%]'>
                                <div
                                    onClick={() => setopen(true)}
                                    className="shadow-sm flex flex-col justify-between pt-2 bg-cover bg-center h-[362px] w-[100%] rounded-t-md cursor-pointer"
                                    style={{ backgroundImage: `url(${bgimage})` }}
                                >
                                    <div className="bg-white m-3 rounded-md p-3 relative">
                                        <FaCaretLeft className="fa-solid fa-caret-left text-white text-[28px] absolute -left-[14px] -top-[10px] rotate-[270deg]" />
                                        <div className="max-h-[260px] overflow-y-auto pr-[5px]">
                                            <div className="font-bold mb-2 text-[#576071] text-[14px]">
                                                {item.name}
                                            </div>
                                            <div className="mb-2 text-[#121519d1] text-[13px]">
                                                {item.header}
                                            </div>
                                            <div className="mb-2 text-[#121519d1] text-[13px]">
                                                {item.body}
                                            </div>
                                            <div className="mb-2 text-[#121519d1] text-[13px]">
                                                {item.footer}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-white p-3">
                                        <div className="font-bold mb-2 text-[#858c97] text-[12px]">
                                            {item.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Templatemodal isOpen={open} onClose={() => setopen(false)} heading={selectedItem.name}>
                <div className='pt-1 pb-6 border-y-[1px] border-[#8b8a8a67] my-2 w-[100%]'>

                    <div className='flex w-[100%] items-center justify-between mb-2'>
                        <span className='flex items-center text-[#858c97] text-[12px]'>
                            {selectedItem.type === 'utility' ? 'Utility' : 'Authentication'}
                            <IoIosArrowForward /> Account creation confirmation
                        </span>
                        <div>
                            <button
                                onClick={() => setExample(!Example)}
                                className={`p-2 text-[12px] font-semibold text-[#000] ${!Example ? 'bg-[#edf1f5]' : ''} border-[1px] border-[#d7dde2] rounded-l-md`}>
                                Parameters
                            </button>
                            <button
                                onClick={() => setExample(!Example)}
                                className={`p-2 text-[12px] font-semibold text-[#000] ${Example ? 'bg-[#edf1f5]' : ''} border-[1px] border-[#d7dde2] rounded-r-md`}>
                                Example
                            </button>
                        </div>
                    </div>

                    <div className='flex w-[100%] gap-2'>
                        <div className='w-[50%]'>
                            <h6 className='text-[#576071] text-[13px] font-bold mt-2'>Enter template details</h6>
                            <span className='flex items-center text-[#858c97] text-[12px]'>
                                If you need to edit the content, select Customise template.
                            </span>
                            <label className='text-[#000] font-semibold text-[14px]' htmlFor="">Name your template</label>
                            <input
                                className='border-[1px] border-[#d4cfcf] rounded-md w-[100%] outline-none py-2 text-[#576071] text-[12px] font-semibold pl-2 mt-2'
                                type="text"
                                value={selectedItem.name || ''}
                                readOnly
                            />

                            {selectedItem.link &&
                                <div className='w-[100%]'>
                                    <span className='flex items-center text-[#858c97] text-[12px] mt-2'>
                                        URL - <BsBoxArrowUpRight className='text-[#3f7fca] text-[14px] font-semibold' /> Verify account
                                    </span>
                                    <input
                                        className='border-[1px] border-[#d4cfcf] rounded-md w-[100%] outline-none py-2 text-[#576071] text-[12px] font-semibold pl-2 mt-2'
                                        type="text"
                                        value={selectedItem.link || ''}
                                        readOnly
                                    />
                                </div>
                            }
                        </div>

                        <div className='w-[50%]'>
                            <div
                                className="shadow-sm flex flex-col justify-between pt-2 bg-cover bg-center w-[100%] rounded-md cursor-pointer"
                                style={{ backgroundImage: `url(${bgimage})` }}
                            >
                                <div className="bg-white m-3 rounded-md p-3 relative">
                                    <FaCaretLeft className="fa-solid fa-caret-left text-white text-[28px] absolute -left-[14px] -top-[10px] rotate-[270deg]" />
                                    <div className="max-h-[260px] overflow-y-auto pr-[5px]">
                                        <div className="font-bold mb-2 text-[#576071] text-[14px]">
                                            {selectedItem.name}
                                        </div>
                                        <div className="mb-2 text-[#121519d1] text-[13px]">
                                            {selectedItem.header}
                                        </div>
                                        <div className="mb-2 text-[#121519d1] text-[13px]">
                                            {selectedItem.body}
                                        </div>
                                        <div className="mb-2 text-[#121519d1] text-[13px]">
                                            {selectedItem.footer}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!Example &&
                                <p className='text-[#858c97] text-center text-[13px]'>
                                    Text in brackets are dynamic. They will update with your content when your message is sent.
                                </p>
                            }
                            {Example &&
                                <p className='text-[#858c97] text-center text-[13px]'>
                                    This is an example of what your customers might see.
                                </p>
                            }
                        </div>
                    </div>
                </div>

                <div className='w-[100%] flex items-center justify-end gap-1 mt-2'>
                    <Link to={`/WAMessage/WATemplate/AddEditTemplate/?templateId=${selectedItem.id}`}>
                        <button className='px-3 py-2 border-[1px] border-[#316bb0] rounded-md hover:bg-[#316bb0] text-[12px] text-[#316bb0] hover:text-[#fff] font-semibold'>
                            Customise Template
                        </button>
                    </Link>
                    <button className='text-[12px] px-3 py-2 border-[1px] border-[#316bb0] rounded-md bg-[#316bb0] text-[#fff] font-semibold'>
                        Submit
                    </button>
                </div>
            </Templatemodal>
        </>
    )
}

export default Templatelibrary